export const MANDATORY_LANGUAGE = 'en';
